import type { Language } from 'element-plus/es/locale/index.mjs'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import zhHk from 'element-plus/es/locale/lang/zh-hk'
import ar from 'element-plus/es/locale/lang/ar'
import ja from 'element-plus/es/locale/lang/ja'
import ko from 'element-plus/es/locale/lang/ko'
import fr from 'element-plus/es/locale/lang/fr'
import es from 'element-plus/es/locale/lang/es'
import ru from 'element-plus/es/locale/lang/ru'
import de from 'element-plus/es/locale/lang/de'
import pt from 'element-plus/es/locale/lang/pt'
import hi from 'element-plus/es/locale/lang/hi'
import vi from 'element-plus/es/locale/lang/vi'
import th from 'element-plus/es/locale/lang/th'
import tr from 'element-plus/es/locale/lang/tr'
import it from 'element-plus/es/locale/lang/it'
import id from 'element-plus/es/locale/lang/id'

// 手动构造语言映射
const elementPlusLangMap: Record<string, Language> = {
  zh_CN: zhCn,
  en,
  zh_HK: zhHk,
  ar,
  ja,
  ko,
  fr,
  es,
  ru,
  de,
  pt,
  hi,
  vi,
  th,
  tr,
  it,
  id,
}

// 提供安全获取函数
export function getElementPlusLang(lang: string): Language {
  return elementPlusLangMap[lang] || zhCn
}

// 语言映射
export const langMap: { name: string; value: string }[] = [
  { name: "English", value: "en" },
  { name: "日本語", value: "ja" },
  { name: "한국인", value: "ko" },
  { name: "Français", value: "fr" },
  { name: "Español", value: "es" },
  { name: "Pусский", value: "ru" },
  { name: "Deutsch", value: "de" },
  { name: "Português", value: "pt" },
  { name: "हिंदी", value: "hi" },
  { name: "Tiếng Việt", value: "vi" },
  { name: "Pilipino", value: "tl" },
  { name: "ภาษาไทย", value: "th" },
  { name: "Türk", value: "tr" },
  { name: "Italiano", value: "it" },
  { name: "bahasa Indonesia", value: "id" },
  { name: "عربي", value: "ar" },
  { name: "中文简体", value: "zh_CN" },
  { name: "中文繁體", value: "zh_HK" },
]

// 获取语言对应文案
export const getLangName = (key: string): string => langMap.find(({ value }) => key === value)?.name || '';
